import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { 
  Calculator,
  ArrowRight,
  Home,
  DoorOpen,
  CheckCircle
} from 'lucide-react';
import { Link } from 'react-router-dom';

const PricingSelection = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-green-50 py-20">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Get Your Instant
              <span className="block text-slate-700">Shutter Quote</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Get Instant Pricing for all of our shutter ranges based on quick measurements then schedule us for a free design visit.
            </p>
          </div>

          {/* Shutter Calculator Card */}
          <div className="max-w-2xl mx-auto">
            <Card className="border-0 shadow-xl hover:shadow-2xl transition-shadow group cursor-pointer">
              <CardContent className="p-8">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{backgroundColor: '#8CB89F20'}}>
                    <Home className="h-10 w-10" style={{color: '#8CB89F'}} />
                  </div>
                  
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">Window Shutters</h2>
                  <p className="text-gray-600 mb-6 text-lg">
                    Premium plantation shutters for your windows. Get instant pricing based on measurements, materials, and style preferences.
                  </p>
                  
                  <div className="space-y-3 mb-8">
                    <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                      <CheckCircle className="h-4 w-4" style={{color: '#8CB89F'}} />
                      <span>Instant Pricing For All Of Our Shutter Ranges At Once</span>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                      <CheckCircle className="h-4 w-4" style={{color: '#8CB89F'}} />
                      <span>Prices Saved To Your Online Account</span>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
                      <CheckCircle className="h-4 w-4" style={{color: '#8CB89F'}} />
                      <span>Multiple Window Support, Price Your Entire Project</span>
                    </div>
                  </div>
                  
                  <Link to="/calculator/shutters">
                    <Button 
                      size="lg" 
                      className="w-full text-white hover:opacity-90 group-hover:scale-105 transition-transform" 
                      style={{backgroundColor: '#8CB89F'}}
                    >
                      <Calculator className="mr-2 h-5 w-5" />
                      Price Shutters
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>

            {/* Internal Doors removed - now focusing solely on shutters */}
          </div>

          {/* Additional Info */}
          <div className="text-center mt-16">
            <div className="max-w-2xl mx-auto p-6 rounded-xl" style={{backgroundColor: '#8CB89F10'}}>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Need Help Choosing?</h3>
              <p className="text-gray-600 mb-4">
                Our family team at Aston Lily Joinery is here to help you find the perfect solution for your home.
              </p>
              <Link to="/contact">
                <Button variant="outline" style={{borderColor: '#8CB89F', color: '#8CB89F'}}>
                  Speak to Our Team
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PricingSelection;